import { render } from "./ResultTable.vue?vue&type=template&id=6130048a&scoped=true"
import script from "./ResultTable.vue?vue&type=script&lang=js"
export * from "./ResultTable.vue?vue&type=script&lang=js"

import "./ResultTable.vue?vue&type=style&index=0&id=6130048a&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\52\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6130048a"]])

export default __exports__